import { PassportUserManagementServiceClientConfigFactory } from '@amzn/coral-config_passport-user-management-service';
import {
  PASSPORT_URL_PREFIXES,
  PUMS_CORAL_CONFIG,
  PUMS_PASSPORT_CORAL_CONFIG,
  URL_PREFIXES,
  URL_PREFIXES_DEPRECATED,
} from './endpointConfig';

const getEnv = () => {
  const url = window.location.href;
  let env;
  if (url.includes(URL_PREFIXES_DEPRECATED.BETA_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.BETA_CONFIG_DEPRECATED;
  } else if (url.includes(URL_PREFIXES_DEPRECATED.GAMMA_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.GAMMA_CONFIG_DEPRECATED;
  } else if (url.includes(URL_PREFIXES_DEPRECATED.PROD_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.PROD_CONFIG_DEPRECATED;
  } else if (url.includes(URL_PREFIXES.BETA_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.BETA_CONFIG;
  } else if (url.includes(URL_PREFIXES.GAMMA_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.GAMMA_CONFIG;
  } else if (url.includes(URL_PREFIXES.PROD_URL_PREFIX)) {
    env = PUMS_CORAL_CONFIG.PROD_CONFIG;
  } else if (url.includes(PASSPORT_URL_PREFIXES.BETA_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
  } else if (url.includes(PASSPORT_URL_PREFIXES.GAMMA_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.GAMMA_CONFIG;
  } else if (url.includes(PASSPORT_URL_PREFIXES.PROD_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.PROD_CONFIG;
  } else {
    env = PUMS_CORAL_CONFIG.LOCAL_DEV;
  }
  return env;
};

export const getAuthEnvUrlForPassport = () => {
  const url = window.location.href;
  let env;
  if (url.includes(PASSPORT_URL_PREFIXES.BETA_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
  } else if (url.includes(PASSPORT_URL_PREFIXES.GAMMA_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.GAMMA_CONFIG;
  } else if (url.includes(PASSPORT_URL_PREFIXES.PROD_URL_PREFIX)) {
    env = PUMS_PASSPORT_CORAL_CONFIG.PROD_CONFIG;
  } else {
    env = PUMS_PASSPORT_CORAL_CONFIG.BETA_CONFIG;
  }

  const requiredUrl =
    PassportUserManagementServiceClientConfigFactory.getConfigForQualifier(env)
      ?.httpEndpoint?.url;
  return requiredUrl;
};

const isProd = () => {
  const env = getEnv();
  return env === PUMS_CORAL_CONFIG.PROD_CONFIG;
};

const envHelper = {
  getEnv,
  isProd,
};

export default envHelper;
